import React from 'react';
import ReactDOM from 'react-dom/client';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import './styles/index.css';
import App from './App';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import EsLocale from 'moment/locale/es';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//import 'dayjs/locale/es';

import CssBaseline from "@mui/material/CssBaseline"
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import './styles/styles.css';

import { coreSetToken } from './components/coreFunctions2';

import BarcodeScannerComponent from 'react-qr-barcode-scanner-18';

localStorage.setItem("api_url", JSON.stringify(process.env));
/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);


const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
    EsLocale
  });

  let _schema = {};

  let _url = ""; //'CoreMetaData/GetSchema/' + ((window.location.search != '') ? window.location.search.substring(1) : 'react_panel_local');
  let _item = {name: ''};
  let _searchString = window.location.search;
  if (_searchString != ''){
    _searchString = _searchString.substring(1);
    let _params = _searchString.split('&');
    _params.forEach(element => {
      let _param = element.split('=');
        if (_param[0] === "urlSchema"){
          _url = _param[1];
        }else{
          if (_param[0] === "anonymous"){
            window[_param[0]] = _param[1];
          }else{
            if (!(_param[0] === "application" || _param[0] === "database" || _param[0] === "domain")){
              coreSetToken(_schema, _param[0], _param[1]);
            }
          }
        }
    });
  }

  let formDefaultProps = {
    "type": "uiComponent",
    "name": _url,
    "props": {
    "jsonSchema": _schema
    }
};

// window.backendParameters = {
//   "COU": {
//     "AzureAd": {
//         "Instance": "https://login.microsoftonline.com/",
//         "Domain": "cousa.com",
//         "TenantId": "55c0c77d-3328-4ae3-8509-7d99f9dfa0ea",
//         "ClientId": "b11df627-5657-42ce-99ed-c560359420ea",
//         "CallbackPath": "/signin-oidc",
//         "SignedOutCallbackPath ": "/signout-callback-oidc",
    
//         // To call an API
//         "ClientSecret": "mULBPDg-m~~2r~503Q5jTYW3iHb.ZM1Lc_"
//       },
//     "Logging": {
//       "LogLevel": {
//         "Default": "Information",
//         "Microsoft": "Warning",
//         "Microsoft.Hosting.Lifetime": "Information"
//       }
//     },
//     "xHalcon.Api": {
//       "UserScope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
//     },
//     "DefaultScope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user",
//     "Backend": {    
//       "COPALHA": {
//         "Url": "https://copalhabackend.evolution.com.uy",
//         "Port": "6042",
//         "Scope": "api://5b9fa850-667c-478c-b299-0b5d03285e79/access_as_user"
//       },
//       "localCOPALHA": {
//         "Url": "https://localhost",
//         "Port": "44306",
//         "Scope": "api://5b9fa850-667c-478c-b299-0b5d03285e79/access_as_user"
//       },      
//       "HALCON": {
//         "Url": "https://halconbackend.evolution.com.uy",
//         "Port": "6043",
//         "Scope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
//       },
//       "localHALCON": {
//         "Url": "https://localhost",
//         "Port": "44350",
//         "Scope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
//       },      
//       "TUCAN": {
//           "Url": "https://tucanbackend.evolution.com.uy",
//           "Port": "6044",
//           "Scope": "api://732c81c4-1337-4b53-a032-152f233bb4d6/access_as_user"
//       },
//       "DUKE": {
//           "Url": "https://dukebackend.evolution.com.uy",
//           "Port": "6045",
//           "Scope": "api://965150a4-7e39-439b-8cc0-d1af9bb0f8cf/access_as_user"
//       },
//       "localTUCAN": {
//         "Url": "https://localhost",
//         "Port": "44351",
//         "Scope": "api://732c81c4-1337-4b53-a032-152f233bb4d6/access_as_user"
//       },
//       "COUCOPALHA": {
//         "Url": "https://coucopalha.azurewebsites.net",
//         "Port": "443",
//         "Scope": "api://5b9fa850-667c-478c-b299-0b5d03285e79/access_as_user"
//       },
//       "COUHALCON": {
//         "Url": "https://couhalcon.azurewebsites.net",
//         "Port": "443",
//         "Scope": "api://60711062-36bc-4cfe-a50e-21bb8a3b5f87/access_as_user"
//       },
//       "COUTUCAN": {
//         "Url": "https://coutucan.azurewebsites.net",
//         "Port": "443",
//         "Scope": "api://732c81c4-1337-4b53-a032-152f233bb4d6/access_as_user"
//       }
//     },
//     "AllowedHosts": "*"
//   },
//   "EVO": {
//     "AzureAd": {
//         "Instance": "https://login.microsoftonline.com/",
//         "Domain": "evolution.com.uy",
//         "TenantId": "57a12fde-984f-4002-96f8-7c2c06d517f9",
//         "ClientId": "23bd5679-f680-47cc-a14c-f150d17b4c3e",
//         "CallbackPath": "/signin-oidc",
//         "SignedOutCallbackPath ": "/signout-callback-oidc",
//         "ClientSecret": "NBy8Q~LzS1Pc6wo6MuOkIMsBRpZyzWdp3oOOeaQZ"
//       },
//       "Logging": {
//         "LogLevel": {
//           "Default": "Information",
//           "Microsoft": "Warning",
//           "Microsoft.Hosting.Lifetime": "Information"
//         }
//       },
//       "Backend": {    
//         "ERP": {
//           "Url": "https://erpbackend.evolution.com.uy",
//           "Port": "6042",
//           "Scope": "api://9caae7f6-d130-441a-9e85-3498ed4c0b4e/access_as_user"
//         },
//         "localERP": {
//           "Url": "https://localhost",
//           "Port": "9002",
//           "Scope": "api://9caae7f6-d130-441a-9e85-3498ed4c0b4e/access_as_user"
//         },      
//         "HALCON": {
//           "Url": "https://evobackend.evolution.com.uy",
//           "Port": "6043",
//           "Scope": "api://cb9a2139-5282-46f7-981a-24a167f528c3/access_as_user"
//         },
//         "TUCAN": {
//           "Url": "https://evobackend.evolution.com.uy",
//           "Port": "6044",
//           "Scope": "api://b420a317-ae3e-4b62-9591-1b656631fd26/access_as_user"
//         },
//         "localHALCON": {
//           "Url": "https://localhost",
//           "Port": "44350",
//           "Scope": "api://cb9a2139-5282-46f7-981a-24a167f528c3/access_as_user"
//         },
//         "localTUCAN": {
//           "Url": "https://localhost",
//           "Port": "44351",
//           "Scope": "api://b420a317-ae3e-4b62-9591-1b656631fd26/access_as_user"
//         },      
//         "EDCupones": {
//           "Url": "https://edcuponesbackend.evolution.com.uy",
//           "Port": "6045",      
//           "Scope": "api://e7663d12-ba23-42b6-8b38-0808267ee125/access_as_user"
//         },
//         "EDSAPMM": {
//           "Url": "https://edsapmmbackend.evolution.com.uy",
//           "Port": "6047",
//           "Scope": "api://80af3e33-59d5-46e9-91de-8141a673df24/access_as_user"
//         },
//         "TCP": {
//           "Url": "https://erpbackend.evolution.com.uy",
//           "Port": "6048",
//           "Scope": "api://293103f5-adfc-469f-be74-5a47d079a0c2/access_as_user"
//         },
//         "GLUE": {
//           "Url": "https://gluebackend.evolution.com.uy",
//           "Port": "6049",
//           "Scope": "api://f6783a84-e5c7-49f6-a8c5-15523c85f8fd/access_as_user"
//         }
//       },
//       "AllowedHosts": "*"
//     }    
//   };

//   if (_searchString != ''){
//     _searchString = _searchString.substring(1);
//     let _params = _searchString.split('&');
//     _params.forEach(element => {
//       let _param = element.split('=');
//         if (_param[0] === "application" || _param[0] === "database" || _param[0] === "domain"){
//           window[_param[0]] = _param[1];
//         }
//     });
  
//   }else{
//     //lo saco del storage de la sesión de windows
//     let _localStorageItem = localStorage.getItem(Object.keys(localStorage).filter(x => {return (x.indexOf('login.request') !== -1 && localStorage.getItem(x).indexOf("index.html") === -1)})[0]);
//     if (_localStorageItem !== null){
//       _searchString = _localStorageItem.split('?')[1];
//       let _params = _searchString.split('&');
//       _params.forEach(element => {
//         let _param = element.split('=');
//           if (_param[0] === "application" || _param[0] === "database" || _param[0] === "domain" || _param[0] === "anonymous"){
//             window[_param[0]] = _param[1];
//           }
//       });  
//     }
//   }

//   if (window.domain){
//     window.backendBaseUrl = window.backendParameters[window.domain].Backend[window.application].Url + ':' + window.backendParameters[window.domain].Backend[window.application].Port + '/' + window.database + '/api/';
//   }

const root = ReactDOM.createRoot(document.getElementById('root'));

const onUpdate = async function(evt, result){
  console.log(result);
}

/**
 * We recommend wrapping most or all of your components in the MsalProvider component. It's best to render the MsalProvider as close to the root as possible.
 */

if (_schema.options !== undefined && _schema.options.anonymous === true){
  root.render(
    <ThemeProvider theme={darkTheme}>
        <CssBaseline />
            <LocalizationProvider dateAdapter={AdapterMoment} Locale={EsLocale}>
                <App {...formDefaultProps}/>
            </LocalizationProvider>    
    </ThemeProvider>
  );  
}else{
  root.render(
      //<React.StrictMode>
          <MsalProvider instance={msalInstance}>
              <ThemeProvider theme={darkTheme}>
                  <CssBaseline />
                      <LocalizationProvider dateAdapter={AdapterMoment} Locale={EsLocale}>
                          <App {...formDefaultProps}/>
                      </LocalizationProvider>    
              </ThemeProvider>
          </MsalProvider>
      //</React.StrictMode>
  );
}
